import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=65647464"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"
import style0 from "./Clientes.vue?vue&type=style&index=0&id=65647464&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports